import React from 'react'
import PropTypes from 'prop-types'

import Hoverable from '../common/HoverableItem'
import CircularProgress from 'material-ui/CircularProgress'

import Queries from './SummaryQueries'

const JobsTableHeader = () => {
  return (
    <div style={styles.listItemContainer(true)}>
      <div style={styles.listColumn(true, null, true)}>Date</div>
      <div style={styles.listColumn(true)}>Name</div>
    </div>
  )
}

const JobsTableRow = ({ index, event, onPress }) => {
  return (
    <Hoverable id={index.toString()} style={styles.row} item={event} onPress={onPress}>
      <div style={{ ...styles.listItemContainer(false) }}>
        <div style={styles.listColumn(false, null, true)}>{ event.endDate }</div>
        <div style={styles.listColumn(false, 320)}>{ event.name }</div>
      </div>
    </Hoverable>
  )
}

JobsTableRow.propTypes = {
  index: PropTypes.number.isRequired,
  event: PropTypes.object.isRequired,
  onPress: PropTypes.func,
  handleActionsClicked: PropTypes.func
}

class JobsTable extends React.Component {

  static propTypes = {
    style: PropTypes.object.isRequired,
    teamId: PropTypes.string.isRequired,
    customerId: PropTypes.string.isRequired,
    contactId: PropTypes.string.isRequired,
    selectedTab: PropTypes.string.isRequired,
    onSelection: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      events: []
    }
  }

  componentWillMount(){
    this.attachListener(this.props)
  }

  componentWillReceiveProps(nextProps){
    if (this.props.customerId !== nextProps.customerId ||
        this.props.contactId !== nextProps.contactId ||
        this.props.selectedTab !== nextProps.selectedTab){
      this.detachListener(this.props)
      this.setState({ loading : true })
      this.attachListener(nextProps)
    }
  }

  componentWillUnmount(){
    this.detachListener(this.props)
  }

  attachListener = props => {
    const { teamId, contactId, customerId } = props
    Queries[props.selectedTab].attach(teamId, contactId, customerId, this.onUpdate)
  }

  detachListener = props => {
    const { teamId, contactId, customerId } = props
    Queries[props.selectedTab].detach(teamId, contactId, customerId, this.onUpdate)
  }

  onUpdate = (snapshots) => {

    const events = []
    snapshots.forEach(snapshot => {
      events.push(snapshot.val())
    })
    this.setState({ events, loading: false })
  }

  returnEmptyState = () => {
    if (this.props.selectedTab === 'pastJobs'){
      return (<div style={styles.zeroItems}>No past jobs are available.</div>)
    } else if (this.props.selectedTab === 'futureJobs'){
      return (<div style={styles.zeroItems}>No future jobs are available.</div>)
    }
  }

  returnLoadingState = () => {
    return (
      <div style={styles.progress}>
        <CircularProgress thickness={2} />
      </div>
    )
  }

  returnEventsComponent = (events) => {
    const eventsComponents = []
    if (this.props.selectedTab === 'pastJobs'){
      for (let i = events.length - 1; i >= 0 ; i--){
        const event = events[i]
        eventsComponents.push(
          <JobsTableRow
            key={i}
            index={i}
            event={event}
            onPress={this.props.onSelection.bind(this, event.eventId, event.endDate)}/>
        )
      }
    } else if (this.props.selectedTab === 'futureJobs'){
      events.forEach((event, idx) => {
        eventsComponents.push(
          <JobsTableRow
            key={idx}
            index={idx}
            event={event}
            onPress={this.props.onSelection.bind(this, event.eventId, event.endDate)}/>
        )
      })
    }
    return eventsComponents
  }

  render() {
    let component = null

    if (this.state.loading){
      component = this.returnLoadingState()
    } else if (!this.state.events.length) {
      component = this.returnEmptyState()
    } else {
      component = this.returnEventsComponent(this.state.events)
    }
    return (
      <div style={this.props.style}>
        <JobsTableHeader />
        <div style={{height: 240, overflowY: 'overlay'}}>
          { component }
        </div>
      </div>
    )
  }

}

export default JobsTable

const styles = {
  progress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 22
  },
  row: {
    borderBottom: 'none'
  },
  listItemContainer: (isHeader) => ({
    display:'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 45,
    justifyContent: 'flex-start',
    borderBottom: isHeader ? '1px solid #527da3' : null,
    paddingTop: 4,
    paddingBottom: 4
  }),
  listColumn: (isHeader, width, isFirstColumn, textAlign) => ({
    color: isHeader ? '#356992' : '#757575',
    fontWeight: isHeader ? 500 : 400,
    letterSpacing: isHeader ? 0.6 : null,
    fontSize: 14,
    width: width || 100,
    marginLeft: isFirstColumn ? 16 : 0,
    textAlign: textAlign || 'left',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }),
  listActionsColumn: {
    width: 144,
    justifyContent: 'center'
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  viewLabel: {
    cursor: 'pointer',
    color: '#179b93'
  },
  zeroItems: {
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: 14,
    paddingTop: 12,
    paddingBottom: 12
  }
}



// WEBPACK FOOTER //
// ./src/customer/CustomerSummary/JobsTable.js